export const getComissionFromCashAdvance = (amount, commission) => {
    if((typeof amount !== 'number') || amount < 0){
      return 0
    }else if ((typeof commission !== 'number' || commission < 0)){
      return 0
    }
    return Math.ceil((amount/60000))*(commission*1.21)
}


/** WEBPACK FOOTER **
 ** ./src/utils/montemar.js
 **/